import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables');
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    // Enable auto-refresh for better session management
    autoRefreshToken: true,
    // Clear session on logout
    persistSession: true,
    // Detect session in URL
    detectSessionInUrl: true,
    // Storage key for session
    storageKey: 'amcare-auth-token',
    // Storage interface
    storage: {
      getItem: (key: string) => {
        try {
          return localStorage.getItem(key);
        } catch {
          return null;
        }
      },
      setItem: (key: string, value: string) => {
        try {
          localStorage.setItem(key, value);
        } catch {
          // Ignore storage errors
        }
      },
      removeItem: (key: string) => {
        try {
          localStorage.removeItem(key);
        } catch {
          // Ignore storage errors
        }
      },
    },
  },
  // Add global configuration for better performance
  global: {
    headers: {
      'X-Client-Info': 'amcare-web-app',
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    },
  },
  // Configure realtime settings
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
}); 